import { StyleSheet, Text, View } from 'react-native';
import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import Home from '../Screens/HomeScreens/Home';
import DeviceActivation from '../Screens/DeviceActivationScreens/DeviceActivation';
import LeadsList from '../Screens/DeviceActivationScreens/LeadsList';
import OportunityList from '../Screens/DeviceActivationScreens/OportunityList'
import InventoryList from '../Screens/DeviceActivationScreens/InventoryList';
const DevActNavigation = () => {
	const Stack = createNativeStackNavigator();
	return (
		<Stack.Navigator>
			<Stack.Screen
				name="Oportunity List"
				component={OportunityList}
				options={{ headerShown: false }}
			/>
			<Stack.Screen
				name="Device Activation"
				component={DeviceActivation}
				options={{ headerShown: false }}
			/>
			<Stack.Screen
				name="Leads List"
				component={LeadsList}
				options={{ headerShown: false }}
			/>
			<Stack.Screen
				name="Inventory List"
				component={InventoryList}
				options={{ headerShown: false }}
			/>
		</Stack.Navigator>
	);
};

export default DevActNavigation;

const styles = StyleSheet.create({});
